import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute('initialized', '');
  }

  get shouldPushPageUrl() {
    return false;
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
